import { CurrencyEnum, getCurrencySymbol } from '@repo/utils'
import React from 'react'
import { Control } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { INPUT_TYPES, InputTypeText } from '../../../../../../../forms'

const TotalQuotationAmounts = ({
  control,
  currency,
  amountHT,
  amountTTC,
}: {
  control: Control<any, any>
  amountHT: string
  amountTTC: string
  currency?: CurrencyEnum
}) => {
  const intl = useIntl()
  const units = getCurrencySymbol(currency)

  return (
    <div className={s.inputAmountSection}>
      <p>
        <FormattedMessage
          id='ui.TotalQuotationAmounts.totalQuote'
          defaultMessage='Montant total du devis'
        />
      </p>
      <div className={s.inputAmountContainer}>
        <InputTypeText
          inputType={INPUT_TYPES.PRICE}
          placeholder={intl.formatMessage({
            id: 'ui.TotalQuotationAmounts.totalHT',
            defaultMessage: 'Montant HT',
          })}
          control={control}
          name='amountHT'
          rules={{ required: true }}
          units={units}
          currency={currency}
          value={amountHT}
        />
        <InputTypeText
          inputType={INPUT_TYPES.PRICE}
          placeholder={intl.formatMessage({
            id: 'ui.TotalQuotationAmounts.totalTTC',
            defaultMessage: 'Montant TTC',
          })}
          control={control}
          name='amountTTC'
          rules={{ required: true }}
          units={units}
          currency={currency}
          value={amountTTC}
        />
      </div>
    </div>
  )
}

export default TotalQuotationAmounts
